import Actions from "../action";

const initialState = {
    isLoading: false,
    token: undefined,
    error: false
}
const ClientCredentialsReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.CLIENT_CREDENTIALS: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.CLIENT_CREDENTIALS_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                token: action.data,
                error: false
            };
        }
        case Actions.CLIENT_CREDENTIALS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                token: undefined,
                error: action.error,
            };
        }
        default:
            return state;
    }
};

export default ClientCredentialsReducer;

export const getClientCredentialsToken = state => state?.CLIENT_CREDS?.token;